import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { deletePokeToUserOwnTractor } from '../../../../api/product/mutations/deletePokeToUserOwnTractor';

export const useDeletePokeToUserOwnTractor = () => {
  const location = useLocation();

  return useMutation(deletePokeToUserOwnTractor, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '찔러보기 삭제 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
